import {React, useContext, useMemo} from 'external/react'
import {moment} from 'external/moment'

import Calendar from 'react-calendar'
import RecentActivity from 'components/recent-activity'
import DashboardGroups from 'components/dashboard-groups'
import NewsItem from 'components/news-item'
import VideoCarousel from 'teacher/components/video-carrusel/videoCarrusel'
import { TeacherContext } from 'teacher/context'

import './dashboard.styl'

export default function Dashboard(props) {
  const context = useContext(TeacherContext)
  const {locked, lockedMessage, translate, profile} = context
  const activeClass = ({date}) => {
    const isActive = context.scheduledDays.find(schedule => moment(date).isSame(schedule, 'day'))
    return isActive ? 'scheduled-day' : null
  }
  const news = locked ? [lockedMessage] : context.news

  const isDreyfous = useMemo(() => /^dreyfous.*/.test(profile.domain), [profile.domain])
  const isDgenius = useMemo(() => profile.institution.project == 'dgenius', [profile.institution.project])

  return (
    <>
      <div className="panel left-side">
        {news.length > 0 && (
          <div className="news">
            <label>
              {translate('news_label')}
            </label>
            <div className="news-list">
                {news.map(NewsItem)}
            </div>
          </div>
        )}
        <div className="activity">
          <label>
            {translate('activity_label')}
          </label>
          <RecentActivity />
        </div>
        <div className="activity video-carrousel">
          <VideoCarousel />
        </div>
      </div>
      <div className="panel right-side">
        <Calendar
          locale={context.language.id}
          formatMonth = {(_, date) => moment(date).format('MMMM')}
          formatMonthYear= {(_, date) => moment(date).format('MMMM YYYY')}
          formatShortWeekday={(_, date) => moment(date).format('dd')}
          tileClassName={activeClass}
          onClickDay= { date => {
            if (locked) return
            const start =  moment(date).toISOString()
            const query = {start, end: start}
            context.navigate({},'/:languageId/:role/calendars/day', {query})
          }}
        />
        <div className="groups">
          <label>
          {translate('dashboard_groups_label')}
          </label>
          <div className="groups-table">
            <DashboardGroups />
          </div>
        </div>
      </div>
  </>
  )
}

